import { useState } from 'react'

interface NewsCardProfilePictureProps {
    fullName: string
    profilePicture: string | null
}

function NewsCardProfilePicture({
    fullName,
    profilePicture,
}: NewsCardProfilePictureProps) {
    const [loadProfilePictureError, setLoadProfilePictureError] =
        useState(false)

    const getInitials = (fullName?: string) => {
        if (typeof fullName !== 'string') return ''
        return fullName
            .split(' ')
            .map((name) => name[0])
            .join('')
            .substring(0, 2)
            .toUpperCase()
    }

    const handleProfilePictureLoadError = () => {
        setLoadProfilePictureError(true)
    }

    return (
        <>
            {profilePicture && !loadProfilePictureError ? (
                <img
                    src={profilePicture}
                    alt={fullName}
                    onError={handleProfilePictureLoadError}
                />
            ) : (
                getInitials(fullName)
            )}
        </>
    )
}

export default NewsCardProfilePicture
